import { seoOgTwitterCreator } from './SeoStore';

export const updateSeoOgTwitterCreator = (value) => seoOgTwitterCreator.update(oldValue => value);
